module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/4/1-c6c87c0f0f8aefde034045ef871dcd44.jpg";